/* eslint-disable max-len */
import routes, { smeBaseName } from "../routes";
import notFoundRegular from "./../assets/gif/declined_regular.gif";

export const authorityType = [
  { value: "AuthorityType1", label: "AuthorityType1" },
  { value: "AuthorityType2", label: "AuthorityType2" }
];

export const getFileUploadErrorMessage = {
  FILE_TOO_SMALL: "The file size is too small. Please upload a file that is at least 10KB",
  FILE_TOO_BIG: "The file size is too big. Please upload a file less than or equal to 5MB",
  INVALID_FILE_TYPE: "The file format is not supported. Please upload a valid file"
};

export const formStepper = [
  {
    step: 1,
    title: "Basic Information",
    paths: [
      routes.applicantInfo,
      routes.existingCustomer,
      routes.verifyOtp,
      routes.verifyEmailOtp,
      routes.borrowAmount,
      routes.basicInformation
    ]
  },
  { step: 2, title: "Company Information", paths: [routes.companyInfo] },
  { step: 3, title: "Company Stakeholders", paths: [routes.stakeholdersInfo] },
  { step: 4, title: "Business Information", paths: [routes.finalQuestions] },
  { step: 5, title: "Upload Documents", paths: [routes.uploadDocuments] },
  {
    step: 6,
    title: "Checks",
    paths: [routes.AECBcheck]
  },
  { step: 7, title: "Company Information", paths: [routes.companyInfoPE] }
];

export const eligibilityFormStepper = [
  { step: 1, title: "Company Information", paths: [routes.companyInfoPE] },
  { step: 2, title: "Company Stakeholders", paths: [routes.stakeholdersInfoPE] },
  {
    step: 4,
    title: "Select Services",
    paths: [routes.selectServices, routes.additionalDocumentSignatories]
  },
  {
    step: 5,
    title: "Upload Documents",
    paths: [routes.uploadDocumentsPE, routes.SubmitApplication]
  }
];

export const agentFormStepper = [
  { step: 1, title: "Search Applications", path: routes.searchProspect }
];

export const searchProspectStepper = [
  {
    step: 1,
    title: "Search Applications",
    paths: [routes.searchProspect],
    titleInfo: ""
  }
];

export const accountNames = {
  starter: "RAKStarter",
  currentAccount: "Current Account",
  elite: "RAKelite"
};

export const accountTitles = {
  starter: "RAKstarter",
  currentAccount: "Current Account",
  elite: "Business Elite"
};

export const digitRegExp = /^\d$/;

export const CONVENTIONAL = "conventional";
export const ISLAMIC = "islamic";
export const FINANCE_TYPE = "RBL ML";

export const OPTIMIZELY_URL = process.env.REACT_APP_OPTIMIZELY_BASE_URL;

export const OPTIMIZELY_PDF_PATH = "/globalassets/RAKBANK-WCMAPI/DigitalBanking/QuickApply/";

export const UAE_CODE = "971";
export const UAE = "AE";
export const UAE_CURRENCY = "AED";
export const DEFAULT_CURRENCY = UAE_CURRENCY;
export const MAX_EMAIL_LENGTH = 50;
export const MAX_STAKEHOLDERS = 12;
export const GCC_OR_UAE_NATIONALITY_LIST = ["BH", "KW", "OM", "QA", "SA", "AE"];

export const REQUEST_LOADING = "loading";
export const REQUEST_SUCCESS = "success";

export const normalScrollHeight = 740;

const RO_EDITING = "12013";
export const CIF_EXIST = "12012";
const INVALID_PROSPECT_ID = "12002";
const OCCURRED_WHILE_CREATING_CIF = "EXP101";
const NO_RESULT_FOUND = "12009";
const CLIENT_SIDE_VALIDATION_ERROR = "FATAL0001";
const HAPPENED_WHILE_PERFORMING_AUDIT_WHILE_UPDATE_PROSPECT = "10004";
const NO_RECORDS_FETCHED_WHILE_RETRIEVING_CORD = "I001F/12000";
const ERROR_OCCURRED_WHILE_PERFORMING_VALIDATION_CHECKS = "EXP101";
const COMMON_SERVER_ERROR = "INV0001";
export const INTEGRATION_CALL_FAILURE = "13002";
export const TOO_MANY_RECORD_FAILURE = "12019";

const RO_STOP =
  "We noticed that your application is incomplete. Not to worry, our team is already working on it.";
const EXIST = "We already have your application. Not to worry, our team is already working on it.";
const INVALID_ID = "Invalid Prospect ID";
const COMMON_ERROR =
  "We already have your application. Not to worry, our team is already working on it.";

export const PROSPECT_STATUSES = {
  ASSESSING: "Assessing",
  DOCUMENTS_NEEDED: "Documents needed",
  NEED_ADDITIONAL_DOCUMENTS: "Need Additional Information/Documents",
  IN_PROGRESS: "In progress"
};

export const ERROR_MESSAGES = {
  [RO_EDITING]: RO_STOP,
  [CIF_EXIST]: EXIST,
  [INVALID_PROSPECT_ID]: INVALID_ID,
  [OCCURRED_WHILE_CREATING_CIF]: COMMON_ERROR,
  [CLIENT_SIDE_VALIDATION_ERROR]: COMMON_ERROR,
  [HAPPENED_WHILE_PERFORMING_AUDIT_WHILE_UPDATE_PROSPECT]: COMMON_ERROR,
  [NO_RECORDS_FETCHED_WHILE_RETRIEVING_CORD]: COMMON_ERROR,
  [ERROR_OCCURRED_WHILE_PERFORMING_VALIDATION_CHECKS]: COMMON_ERROR,
  [COMMON_SERVER_ERROR]: COMMON_ERROR
};

export const APP_STOP_SCREEN_RESULT = "stop";
export const HANDLED_ERROR_CODES = [
  RO_EDITING,
  CIF_EXIST,
  INVALID_PROSPECT_ID,
  OCCURRED_WHILE_CREATING_CIF,
  CLIENT_SIDE_VALIDATION_ERROR,
  HAPPENED_WHILE_PERFORMING_AUDIT_WHILE_UPDATE_PROSPECT,
  NO_RECORDS_FETCHED_WHILE_RETRIEVING_CORD,
  ERROR_OCCURRED_WHILE_PERFORMING_VALIDATION_CHECKS,
  COMMON_SERVER_ERROR
];

export const IGNORE_ERROR_CODES = [NO_RESULT_FOUND, RO_EDITING];

export const COMPANY_DOCUMENTS = "companyDocuments";
export const STAKEHOLDER_DOCUMENTS = "stakeholdersDocuments";
export const RO_DOCUMENTS = "agentJourneyDocuments";
export const SIGNATORY_DOCUMENTS = "signatoryDocuments";
export const PASSPORT_PHOTO_DOCUMENTS = "passportPhotoDocuments";
export const OTHER_DOCUMENTS = "otherDocuments";
export const ADDITIONAL_DOCUMENTS = "additionalDocuments";
export const PROSPECT_DOCUMENT = "prospectDocument";
export const COMPANY_KYC_DOCUMENTS = "companyKYCDocuments";
export const SIGNBOARD_PROOF_DOC = "signboardProofDoc";
export const OUTSOURCED_STAFF_PROOF = "outsourcedStaffProof";
export const OTHER_COMPANY_SIGNBOARD_PROOF_DOC = "otherCompanySignboardProofDoc";
export const TELEPHONE_DEWA_PROOF = "telephoneOrDEWAProof";

export const COMPANY_BANK_STATEMENTS = "companyBankStatements";
export const COMPANY_ADDRESS_PROOF = "companyAddressProof";
export const COMPANY_INVOICES = "companyInvoices";
export const PERSONAL_BANK_STATEMENTS = "personalBankStatements";
export const PERSONAL_BACKGROUND = "personalBackground";
export const SIGNATORY_INVOLVEMENT_PROOF = "signatoryInvolvementProof";
export const SISTER_COMPANY_TL_PROOF = "sisterCompanyTL";
export const RO_SIGNATORY_DOCUMENTS = "roSignatoryDocuments";

export const COMPANY_BANK_STATEMENTS_DOCTYPE = "Bank_Statements";
export const COMPANY_ADDRESS_PROOF_DOCTYPE = "Company Address Proof";
export const COMPANY_INVOICES_DOCTYPE = "Invoices_Contracts_Shipment_MOU_Custom";
export const PERSONAL_BANK_STATEMENTS_DOCTYPE = "personal Bank Statements";
export const PERSONAL_BACKGROUND_DOCTYPE = "CV / Personal Background";
export const SIGNBOARD_PROOF_DOCTYPE = "Sign Board Proof";
export const OTHER_COMPANY_SIGNBOARD_PROOF_DOCTYPE = "Other Company Sign Board Proof";

export const companyMultiDocs = [COMPANY_BANK_STATEMENTS, COMPANY_INVOICES];
export const stakeholderMultiDocs = [PERSONAL_BANK_STATEMENTS, PERSONAL_BACKGROUND];

export const SUPPORTED_FILE_FORMAT_TEXT = "Supported formats: PDF, JPG, PNG | 5MB max. | 10KB min.";

/* Action Types */
export const SAVE = "save";
export const SUBMIT = "submit";

/* Save Types */
export const DECLINED = "DECLINE";
export const AUTO = "auto";
export const CONTINUE = "continue";
export const NEXT = "next";
export const sales = "sales";
// Enable it once we have this on DEH
// export const CUSTOMER = "CUSTOMER";
// export const RO = "RO";

export const SIGNING_TRANSACTIONS_TYPE = {
  ALL: "101",
  ANY: "100",
  OTHER: "000"
};

//ro-assist-brd1-3
export const applicationdedupe = [
  {
    screeningNotes: "DECLINE",
    link: true,
    buttons: [
      {
        link: routes.currentAccount,
        label: "Go to home page"
      }
    ]
  },
  {
    screeningNotes: "INELIGIBLE",
    link: true,
    buttons: [
      {
        link: routes.currentAccount,
        label: "Go to home page"
      }
    ]
  },
  {
    screeningNotes: "PENDING",
    link: true,
    buttons: [
      {
        link: routes.currentAccount,
        label: "Continue"
      }
    ]
  },
  {
    screeningNotes: "SUCCESS",
    link: true,
    buttons: [
      {
        link: routes.currentAccount,
        label: "No, thanks"
      },
      {
        link: routes.currentAccount,
        label: "Yes"
      }
    ]
  },
  {
    screeningNotes: "WITH_RO",
    link: true,
    buttons: [
      {
        link: routes.currentAccount,
        label: "No, thanks"
      },
      {
        link: routes.currentAccount,
        label: "Yes"
      }
    ]
  }
];

export const screeningStatus = [
  {
    error: "Dedupe",
    screeningType: "Dedupe Check"
  },
  {
    error: "Application Dedupe",
    screeningType: "Application Dedupe Check"
  },
  {
    error: "Not Registered In UAE",
    screeningType: "Country Of Incorporation Check"
  },
  {
    error: "Big Company",
    screeningType: "ShareHolderCount Check"
  },
  {
    error: "BlackList",
    screeningType: "Blacklist Check"
  },
  {
    error: "Too many Stakeholders",
    screeningType: "Too many Stakeholders Check"
  },
  {
    error: "Total No of Documents",
    screeningType: "Total No of Documents uploaded check"
  },
  {
    error: "Policy",
    screeningType: "Policy Check"
  }
];

export const SCREENING_FAIL_REASONS = ["Decline", "Match", "Loan Decline"];

export const screeningStatusDefault = {
  icon: notFoundRegular,
  error: "Default"
};

export const DATE_FORMAT = "yyyy-MM-dd";
export const DATE_TIME_FORMAT = "yyyy-MM-dd HH:mm";
export const SEARCH_TIME_FORMAT = "HH:mm:ss";
export const TIME_FORMAT = "HH:mm";
export const YEAR_FORMAT = "yyyy";
export const FILE_NAME_DELIMITER = "_";
export const FILE_NAME_PREFIX = "LN";

export const VIEW_IDS = {
  CompanyInfo: "/CompanyInfo",
  StakeholdersInfo: "/StakeholdersInfo",
  FinalQuestions: "/FinalQuestions",
  UploadDocuments: "/UploadDocuments",
  SelectServices: "/SelectServices",
  SubmitApplication: "/SubmitApplication",
  SearchProspect: "/SearchProspect",
  SearchedAppInfo: "/SearchedAppInfo",
  ApplicationSubmitted: "/ApplicationSubmitted",
  ReUploadDocuments: "/ReUploadDocuments",
  BorrowAmount: "/BorrowAmount",
  AecbFtsCheck: "/AECB-FTS-Check",
  PostEligibilityCompanyInfo: "/post-eligibility/CompanyInfo",
  PostEligibilityStakeholdersInfo: "/post-eligibility/StakeholdersInfo",
  PostEligibilityUploadDocuments: "/post-eligibility/UploadDocuments",
  Eligibility: "/Eligibility",
  BasicInformation: "/BasicInformation"
};

export const ACTION_TYPES = {
  save: "save",
  submit: "submit"
};

export const SOLE_PROPRIETOR = "1";

export const PRE_ELIGIBILITY_FINAL_QUESTIONS_COMPANY_ID = "pre-eligibility-finalQuestionsCompany";
export const PRE_ELIGIBILITY_COMPANY_SIGNATORY_ID = "pre-eligibility-companySignatory_";

export const STEP_STATUS = {
  AVAILABLE: "AVAILABLE",
  NOT_AVAILABLE: "NOT_AVAILABLE",
  COMPLETED: "COMPLETED",
  RESET: "RESET"
};

export const OTP_TYPES = {
  ComeBackLoginWithProspectId: "CSPID",
  ComeBackLoginWithoutProspectId: "CSWP",
  AECBFTS: "BFAF",
  CustomerDropSalesPick: "CUSTD",
  ProspectIdAndMobile: "ONBA",
  salesAssist: "BFSA",
  additioanlDocs: "OAIA"
};
// Company Check list

export const NEGATIVE_LIST_CHECK = {
  screeningType: "Negative List Check",
  screeningStatus: "Not completed",
  screeningLabel: "Negative List"
};

export const POLICY_CHECK = {
  screeningType: "Policy Check",
  screeningStatus: "Not completed",
  screeningLabel: "Policy Check"
};

export const BLACKLIST_CHECK = {
  screeningType: "Blacklist Check",
  screeningStatus: "Not completed",
  screeningLabel: "Blacklist Check"
};

export const DEDUPE_CHECK = {
  screeningType: "Dedupe Check",
  screeningStatus: "Not completed",
  screeningLabel: "Dedupe"
};
export const ISSHAREHOLDERACOMPANY_CHECK = {
  screeningType: "Company is a Stakeholder Check",
  screeningStatus: "Not completed",
  screeningLabel: "Company is a Stakeholder"
};
export const MOBILE_SUB_INDUSTRY_CHECK = {
  screeningType: "Mobile phones Sub-industry Check",
  screeningStatus: "Not completed",
  screeningLabel: "Mobile phones Sub-industry"
};

export const COMPANY_CHECK_NAMES = [
  DEDUPE_CHECK,
  POLICY_CHECK,
  ISSHAREHOLDERACOMPANY_CHECK,
  NEGATIVE_LIST_CHECK,
  BLACKLIST_CHECK,
  MOBILE_SUB_INDUSTRY_CHECK
];

export const AUTO_SAVE_INTERVAL = 40000;

export const CAMPAGIN_PARAMKEY = "campaign";
export const CAMPAGIN_PARAMVALUE = "sale";
export const BYTES_IN_MEGABYTE = 1048576;

export const UPLOADED = "Uploaded";

export const DEFAULT_REFERRAL_NAME = "Direct";
export const USER_IDLE_TIMEOUT = (process.env.REACT_APP_SESSION_TIMEOUT - 1) * 60 * 1000;
export const EXPIRY_INTERVAL = 60;

export const BUSINESS_FINANCE_ROUTE_PARAM = "business-finance";
export const CAPITAL_FINANCE_ROUTE_PARAM = "capital-finance";
export const ASSET_BASED_ROUTE_PARAM = "asset-based-finance";
export const BUSINESS_FINANCE_ISLAMIC_ROUTE_PARAM = "business-finance-islamic";
export const CAPITAL_FINANCE_ISLAMIC_ROUTE_PARAM = "capital-finance-islamic";
export const ASSET_BASED_ISLAMIC_ROUTE_PARAM = "asset-based-finance-islamic";

export const UPLOAD_ADDITIONAL_DOCS = "upload-additional-documents";

export const financeNames = {
  businessFinance: "Business",
  capitalFinance: "Term Working Capital",
  assetBasedFinance: "Asset Based"
};

export const financeTitles = {
  [CONVENTIONAL]: {
    businessFinance: "Business Loan",
    capitalFinance: "Term and Working \nCapital Finance",
    assetBasedFinance: "Asset Based Loan"
  },
  [ISLAMIC]: {
    businessFinance: "Business Finance",
    capitalFinance: "Term and Working Capital Finance",
    assetBasedFinance: "Asset Based Finance"
  }
};

export const financeColorCodes = {
  [CONVENTIONAL]: {
    titleFinance: { borderTop: "#CCC", background: "#FFF" },
    businessFinance: { borderTop: "#E01E00", background: "#FDFCFC" },
    capitalFinance: { borderTop: "#BC1016", background: "#F9F6F6" },
    assetBasedFinance: { borderTop: "#8D0C10", background: "#F5F0F0" }
  },
  [ISLAMIC]: {
    titleFinance: { borderTop: "#CCC", background: "#FFF" },
    businessFinance: { borderTop: "#157947", background: "#FDFCFC" },
    capitalFinance: { borderTop: "#0F693C", background: "#F9F6F6" },
    assetBasedFinance: { borderTop: "#074727", background: "#F5F0F0" }
  }
};

export const financeTypeTitles = {
  [CONVENTIONAL]: {
    [financeNames.businessFinance]: "Business \nLoan",
    [financeNames.capitalFinance]: "Term and Working Capital Finance",
    [financeNames.assetBasedFinance]: "Asset Based \nLoan"
  },
  [ISLAMIC]: {
    [financeNames.businessFinance]: "Business \nFinance",
    [financeNames.capitalFinance]: "Term and Working Capital Finance",
    [financeNames.assetBasedFinance]: "Asset Based \nFinance"
  }
};

export const detailedFinanceRoutesMap = {
  [financeNames.businessFinance]: {
    [CONVENTIONAL]: `${smeBaseName}/${BUSINESS_FINANCE_ROUTE_PARAM}`,
    [ISLAMIC]: `${smeBaseName}/${BUSINESS_FINANCE_ISLAMIC_ROUTE_PARAM}`
  },
  [financeNames.capitalFinance]: {
    [CONVENTIONAL]: `${smeBaseName}/${CAPITAL_FINANCE_ROUTE_PARAM}`,
    [ISLAMIC]: `${smeBaseName}/${CAPITAL_FINANCE_ISLAMIC_ROUTE_PARAM}`
  },
  [financeNames.assetBasedFinance]: {
    [CONVENTIONAL]: `${smeBaseName}/${ASSET_BASED_ROUTE_PARAM}`,
    [ISLAMIC]: `${smeBaseName}/${ASSET_BASED_ISLAMIC_ROUTE_PARAM}`
  }
};

export const kfsFinanceUrls = {
  [financeNames.businessFinance]: {
    [CONVENTIONAL]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}Conventional/kfs030rakbusinessloan-150623-nosignature.pdf`,
    [ISLAMIC]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}Islamic/kfs075islamicrakbusinessfinance17062023-nosignature.pdf`
  },
  [financeNames.capitalFinance]: {
    [CONVENTIONAL]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}Conventional/kfs098termandworkingcapitalfinance-nosignature-15062023.pdf`,
    [ISLAMIC]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}Islamic/kfs102islamictermandworkingcapitalfinance17062023-nosignature.pdf`
  },
  [financeNames.assetBasedFinance]: {
    [CONVENTIONAL]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}Conventional/kfs029assetbasedloan150623-nosignature.pdf`,
    [ISLAMIC]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}Islamic/kfs078islamicassetbasedfinance170623-nosignature.pdf`
  }
};

export const detailedFinanceRoutes = [
  `${smeBaseName}/${BUSINESS_FINANCE_ROUTE_PARAM}`,
  `${smeBaseName}/${BUSINESS_FINANCE_ISLAMIC_ROUTE_PARAM}`,
  `${smeBaseName}/${CAPITAL_FINANCE_ROUTE_PARAM}`,
  `${smeBaseName}/${CAPITAL_FINANCE_ISLAMIC_ROUTE_PARAM}`,
  `${smeBaseName}/${ASSET_BASED_ROUTE_PARAM}`,
  `${smeBaseName}/${ASSET_BASED_ISLAMIC_ROUTE_PARAM}`
];

export const financeTypeURIs = {
  [BUSINESS_FINANCE_ROUTE_PARAM]: {
    financeType: financeNames.businessFinance,
    isIslamicBanking: false
  },
  [CAPITAL_FINANCE_ROUTE_PARAM]: {
    financeType: financeNames.capitalFinance,
    isIslamicBanking: false
  },
  [ASSET_BASED_ROUTE_PARAM]: {
    financeType: financeNames.assetBasedFinance,
    isIslamicBanking: false
  },
  [BUSINESS_FINANCE_ISLAMIC_ROUTE_PARAM]: {
    financeType: financeNames.businessFinance,
    isIslamicBanking: true
  },
  [CAPITAL_FINANCE_ISLAMIC_ROUTE_PARAM]: {
    financeType: financeNames.capitalFinance,
    isIslamicBanking: true
  },
  [ASSET_BASED_ISLAMIC_ROUTE_PARAM]: {
    financeType: financeNames.assetBasedFinance,
    isIslamicBanking: true
  }
};

/* eslint-disable max-len */
export const applicationOverviewRoutesMap = {
  [financeNames.businessFinance]: {
    [CONVENTIONAL]: `${smeBaseName}/${BUSINESS_FINANCE_ROUTE_PARAM}/application-overview`,
    [ISLAMIC]: `${smeBaseName}/${BUSINESS_FINANCE_ISLAMIC_ROUTE_PARAM}/application-overview`
  },
  [financeNames.capitalFinance]: {
    [CONVENTIONAL]: `${smeBaseName}/${CAPITAL_FINANCE_ROUTE_PARAM}/application-overview`,
    [ISLAMIC]: `${smeBaseName}/${CAPITAL_FINANCE_ISLAMIC_ROUTE_PARAM}/application-overview`
  },
  [financeNames.assetBasedFinance]: {
    [CONVENTIONAL]: `${smeBaseName}/${ASSET_BASED_ROUTE_PARAM}/application-overview`,
    [ISLAMIC]: `${smeBaseName}/${ASSET_BASED_ISLAMIC_ROUTE_PARAM}/application-overview`
  }
};

export const quickApplyAccounts = "/business/accounts";

export const applicationOverviewRoutes = [
  `${smeBaseName}/${BUSINESS_FINANCE_ROUTE_PARAM}/application-overview`,
  `${smeBaseName}/${BUSINESS_FINANCE_ISLAMIC_ROUTE_PARAM}/application-overview`,
  `${smeBaseName}/${CAPITAL_FINANCE_ROUTE_PARAM}/application-overview`,
  `${smeBaseName}/${CAPITAL_FINANCE_ISLAMIC_ROUTE_PARAM}/application-overview`,
  `${smeBaseName}/${ASSET_BASED_ROUTE_PARAM}/application-overview`,
  `${smeBaseName}/${ASSET_BASED_ISLAMIC_ROUTE_PARAM}/application-overview`
];
export const AECB_FTS_CONSENT = "aecb-fts-consent";

export const consentVerifiedRoutesMap = {
  [UPLOAD_ADDITIONAL_DOCS]: `${smeBaseName}/${UPLOAD_ADDITIONAL_DOCS}/submitted`
};

export const verifyTypeRoutesMap = {
  [UPLOAD_ADDITIONAL_DOCS]: `${smeBaseName}/${UPLOAD_ADDITIONAL_DOCS}/:id`,
  [AECB_FTS_CONSENT]: `${smeBaseName}/${AECB_FTS_CONSENT}/:id/verify`
};

export const consentTypeTitle = {
  [UPLOAD_ADDITIONAL_DOCS]: "Upload your Documents"
};

export const licenseExpiryLabel = "Expiry";
export const anticipatedTxnYearLabel = "Year";

const RELATIVE_ADDRESS = "Relative Address";
const HOME_COUNTRY_ADDRESS = "Home Country Address";
const UAE_SHAREHOLDER_ADDRESS = "UAE Shareholder Address";
const NON_UAE_SHAREHOLDER_ADDRESS = "Non-UAE Shareholder Address";
const PASSPORT_PHOTO_PAGE = "Color Photo of passport on photo page";
const EMIRATES_ID_FRONT = "Photo of EID Front";
const PASSPORT_VISA_PAGE = "Photo of Passport on Visa Page";
const CONSTITUTIONAL_DOC = "Constitutional Doc. -MOA/AOA/SC/PA/SA";
const UPLOAD_CV_DOC = "CV doc";

export const ADDRESS_TYPES = [
  RELATIVE_ADDRESS,
  HOME_COUNTRY_ADDRESS,
  UAE_SHAREHOLDER_ADDRESS,
  NON_UAE_SHAREHOLDER_ADDRESS
];

export const STAKEHOLDER_TYPES = [
  PASSPORT_PHOTO_PAGE,
  EMIRATES_ID_FRONT,
  PASSPORT_VISA_PAGE,
  CONSTITUTIONAL_DOC,
  UPLOAD_CV_DOC
];

export const YES_NO_NA_OPTIONS = [
  {
    key: "Y",
    code: "Y",
    displayText: "Yes",
    value: "Y",
    subGroup: null
  },
  {
    key: "N",
    code: "N",
    displayText: "No",
    value: "N",
    subGroup: null
  },
  {
    key: "NA",
    code: "NA",
    displayText: "NA",
    value: "NA",
    subGroup: null
  }
];

export const AUTOSAVE_DISABLE_ROUTES = [
  routes.userVerify,
  routes.userAuthorize,
  routes.userAuthorized,
  routes.uploadAdditionalDocumentsVerify,
  routes.additionalDocuments,
  routes.additionalDocumentsSubmitted,
  routes.consentVerify,
  routes.aecbFtsAuthorize,
  routes.consentAuthorized,
  routes.aecbFtsAuthorizeGenerated,
  routes.uploadAdditionalDocumentsVerifyGenerated,
  routes.userVerifyGenerated
];

export const EMAIL_IDENTIFIERS = {
  RO_Authorize: "RO_Authorize",
  Sales_Assist: "Sales_Assist",
  CustAddDocSubmit: "CustAddDocSubmit",
  Document: "Document"
};

export const SUB_SOURCE = {
  ClientApply: "Client Apply",
  RMApply: "RM Apply",
  SalesAssist: "Sales Assist",
  DropOff: "Drop Off"
};

export const faqURIs = {
  [BUSINESS_FINANCE_ROUTE_PARAM]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}businessloan-13-02-2020-en.pdf`,
  [BUSINESS_FINANCE_ISLAMIC_ROUTE_PARAM]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}aj00807businessfinance-20-02-2020.pdf`,
  [CAPITAL_FINANCE_ROUTE_PARAM]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}aj00183raktradefinancespguidetradeonly-10-02-2020en.pdf`,
  [CAPITAL_FINANCE_ISLAMIC_ROUTE_PARAM]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}aj00807tradefinance-20-02-2020.pdf`,
  [ASSET_BASED_ROUTE_PARAM]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}aj00183rakbusinessequipmentfinance-02-05-2021-toclient-en.pdf`,
  [ASSET_BASED_ISLAMIC_ROUTE_PARAM]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}aj00807assetfinance-02-05-2021-toclient-en.pdf`
};

export const faqConIslamicPDF = {
  [CONVENTIONAL]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}loanshieldcustomertcs.pdf`,
  [ISLAMIC]: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}customertc-takafulfinanceshield.pdf`
};

export const financeTypes = [
  { param: "rbl", value: "Business" },
  { param: "twc", value: "Term Working Capital" },
  { param: "abf", value: "Asset Based" }
];
export const financeTypeParamKey = "finance-type";
export const isIslamicBankingParamKey = "islamic-banking";

export const COMPANY = "company";

export const roSubmittedAppStatuses = [
  "Declined",
  "Withdraw",
  "Successful",
  "In progress",
  "Information Pending"
];

export const CHAT_INFO = {
  HEADER_ENG: "Important Info:",
  HEADER_AR: ":معلومات مهمة",
  DESC_ENG:
    "\nWhile our complete revamped bilingual webchat is work in progress, to view the current content in Arabic, simply select Arabic Language from the Accessibility menu.",
  DESC_AR:
    "\nنحن بصدد تجديد دردشة الويب ثنائية اللغة بالكامل، ولذلك، لعرض المحتوى الحالي باللغة العربية، ما عليك سوى تحديد اللغة العربية من قائمة إمكانية الوصول المتوفرة على موقعنا",
  ICON_DESC_ENG: "To chat with us in Arabic,",
  ICON_DESC_AR: "للتكلم معنا بالعربية",
  PLEASE_CALL_ENG: "please call",
  PLEASE_CALL_AR: "يرجى الاتصال على",
  PHONE_NUM: "04 213 0000"
};

export const AUTH_CLIENT_ID = "bbg-web-onboarding";
export const AUTH_RESOURCE_TYPE = "bbg_loans_onboarding";
export const AGENT_AUTH_RESOURCE_TYPE = "bbg_agent_loans_onboarding";
export const AUTH_CLIENT_SECRET = process.env.REACT_APP_AUTH_CLIENT_SECRET;
export const REACT_APP_AUTH_API_KEY = process.env.REACT_APP_AUTH_API_KEY;

export const OTP_CHANNELS = {
  SMS: "sms",
  EMAIL: "email"
};
